
import React, { useEffect, useRef, useState } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { dbGetGameUuidList } from "../utils/db-functions";
import getImageSrc from "../utils/get-image-src";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faUser } from '@fortawesome/free-solid-svg-icons'

import ScrollButtons from './ScrollButtons';
import CategoryTitle from "./CategoryTitle";

import 'dotenv/config';

export default function GamesRowPragmaticLive() {
    const CASINO_ID = process.env.REACT_APP_DGA_CASINO_ID;
    const MAX_COUNT = 30;

    const [games, setGames] = useState({});
    const [info, setInfo] = useState({});
    const [count, setCount] = useState(0);

    const container = useRef(null);

    useEffect(() => {
        let batchData = {};
        
        const timeout = setTimeout(() => {
            console.log('DGA Component check');
            setInfo({ ...info, ...batchData });

            if (!window.dga) {
                setCount(count + 1);
            }
        }, 5000);

        if (count >= MAX_COUNT) {
            clearTimeout(timeout);
        }

        if (window.dga) {
            window.dga.onMessage = function (data) {
                // console.log('DGA data feed');
                // console.log(data);

                /** dga.available response */
                if (data.hasOwnProperty('tableKey')) {
                    /** Find all available games */
                    const keyList = data.tableKey;
    
                    /** Get all available games */
                    dbGetGameUuidList(keyList).then(response => {
                        const gameList = response?.data?.docs;
    
                        if (gameList?.length > 0) {
                            let tempGames = {};
    
                            gameList.forEach(game => {
                                /** Add game information to games object */
                                tempGames[game.uuid] = game;
    
                                /** Subscribe to game updates */
                                window.dga.subscribe(CASINO_ID, game.uuid, 'CAD');
                            });
    
                            setGames(tempGames);
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                }
    
                /** dga.subscribe response */
                if (data.hasOwnProperty('tableId')) {
                    let tempInfo = {};
                    let result = null;
    
                    try {
                        if (data?.last20Results) {
                            result = data?.last20Results[0]
                        }
                    } catch (e) { }
    
                    try {
                        if (data?.gameResult) {
                            result = data?.gameResult[0]
                        }
                    } catch (e) { }
    
                    tempInfo[data.tableId] = {
                        minBet: data?.tableLimits?.minBet,
                        maxBet: data?.tableLimits?.maxBet,
                        maxPlayers: data?.tableLimits?.maxPlayers,
                        seatedPlayers: data?.totalSeatedPlayers,
                        dealer: data?.dealer?.name,
                        result: result
                    }
    
                    batchData = { ...batchData, ...tempInfo }
                }
            }
        }
        
        return () => {
            clearTimeout(timeout);
        }
    }, [info]);

    return (
        <>
            {
                Object.keys(games).length > 0 && (
                    <Container fluid="lg" className="game-category-container game-row-container section-margin" id="pragmatic-dga-live">
                        <CategoryTitle title="Pragmatic Play Live" />
                        <div className="position-relative">
                            <div className="game-row-wrapper" ref={container}>
                                {
                                    Object.entries(games).map(([key, game], i) => {
                                        return <GameTilePragmaticLive game={game} info={info[key]} key={`pragmatic-dga-live-${game.id}-${i}`} />
                                    })
                                }
                            </div>

                            <ScrollButtons container={container} />
                        </div>
                    </Container>
                )
            }
        </>


    );
}

function GameTilePragmaticLive({ game, info }) {
    const locale = useSelector((state) => state.globalContent.data.locale);
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);

    function kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
    }

    if (!game) {
        return (
            <div className="game-tile-placeholder-wrapper">
                <Placeholder as="div" animation="glow" className='mb-1 game-tile-image-placeholder-wrapper'>
                    <Placeholder xs={12} className="game-tile-image-placeholder" />
                </Placeholder>
                <Placeholder as="p" animation="glow" className='mb-0'>
                    <Placeholder xs={8} size="sm" style={{ borderRadius: '6px' }} />
                </Placeholder>
                <Placeholder as="p" animation="glow" className='mb-0'>
                    <Placeholder xs={5} size="sm" style={{ borderRadius: '6px' }} />
                </Placeholder>
            </div>
        )
    }

    return <>
        <Link to={`${userLoggedIn ? `/${locale}/game/${game.id}` : `?register&game=${game.id}`}`} className={`game-tile-container ${game.provider === 'Pragmatic Play' && game.tags.toLowerCase().includes('live') ? 'pragmatic-live' : ''}`} >
            <div className="game-tile-image-wrapper">

                {/* Min/Max bet */}
                {
                    info?.minBet && info?.maxBet && (
                        <div className="game_tile_live-minmax_bet">
                            <span><FontAwesomeIcon icon={faUser} />&nbsp;&nbsp;{info?.seatedPlayers} / {info?.maxPlayers}</span>
                            <br />
                            <span>${info?.minBet} - ${kFormatter(info?.maxBet)}</span>
                        </div>
                    )
                }
                {/* Results */}
                {
                    info?.result && (
                        <>
                            {/* Roulette red black green */}
                            {
                                info?.result?.result >= 0 && info?.result?.color && (
                                    <div className={`game_tile_result-roulette roulette-win-${info?.result?.color}`}>
                                        <span>{info?.result?.result}</span>
                                    </div>
                                )
                            }
                            {/* BOOM CITY */}
                            {
                                info?.result?.powerUpTotal && (
                                    <div className={`game_tile_result-scibo`}>
                                        <span>{info?.result?.result}</span>
                                    </div>

                                )
                            }
                            {/* Dragon tiger */}
                            {
                                info?.result?.gameResult >= 0 && info?.result?.winner && (
                                    <div className="game_tile_result-scibo">
                                        <span>{info?.result?.gameResult} {info?.result?.winner}</span>
                                    </div>
                                )
                            }
                            {/* Baccarat */}
                            {
                                info?.result?.banker >= 0 && info?.result?.player >= 0 && (
                                    <div className="game_tile_result-baccarat">
                                        <span>{info?.result?.winner?.replace('_', ' ')}</span>
                                    </div>
                                )
                            }
                        </>
                    )
                }
                {/* Live Tag */}
                {
                    !game.tags ? null :
                        <>
                            {
                                game.tags.toLowerCase().includes('live') && (
                                    <div className="tag-container-left">
                                        <span className="img-live" ></span>
                                        <span className="tag-name">Live</span>
                                    </div>
                                )
                            }
                        </>
                }

                <div className="game-tile-image-cover" style={{ backgroundImage: `url(${getImageSrc(game.image)}` }}></div>
                <img className="game-tile-image" src={getImageSrc(game.image)} alt={game.name} />

                <div className="game-tile-overlay">
                    <FontAwesomeIcon icon={faPlay} className="game-tile-overlay-icon" />
                </div>
            </div>
            <p className="game-tile-title">{game.name}</p>
            <p className="game-tile-provider">{game.provider}</p>
        </Link>
    </>
}